import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import {
    IdentificationCard,
    SignOut,
    User as UserIcon,
    Shield,
} from "@phosphor-icons/react";
// import LanguageSwitcher from "./LanguageSwitcher";

export default function Nav() {
    const { user, logout } = useAuth();
    const nav = useNavigate();
    const loc = useLocation();
    const isStudio = loc.pathname.startsWith("/studio/");
    if (isStudio) return null;

    return (
        <header
            data-testid="site-nav"
            className="sticky top-0 z-40 bg-white/70 backdrop-blur-xl border-b border-zinc-200"
        >
            <div className="h-1 g-violet" />
            <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
                <Link
                    to="/"
                    className="flex items-center gap-2 group"
                    data-testid="nav-logo"
                >
                    <img
                        src="/id-card-gen-logo.png"
                        alt="IDCardGen"
                        className="h-12 sm:h-14 w-auto"
                    />
                    <span className="hidden sm:inline text-[10px] tracking-[0.18em] uppercase bg-clip-text text-transparent bg-gradient-to-r from-violet-600 to-pink-600 font-semibold">
                        Generate Smart ID Cards Instantly
                    </span>
                </Link>

                <nav className="hidden md:flex items-center gap-1">
                    <Link to="/" className="btn-ghost" data-testid="nav-home">
                        Home
                    </Link>
                    <Link
                        to="/pricing"
                        className="btn-ghost"
                        data-testid="nav-pricing"
                    >
                        Pricing
                    </Link>
                    <Link
                        to="/offer"
                        className="btn-ghost text-pink-600 font-semibold"
                        data-testid="nav-offer"
                    >
                        Offers
                    </Link>
                    <Link
                        to="/help"
                        className="btn-ghost"
                        data-testid="nav-help"
                    >
                        Help
                    </Link>
                    {user && user.role === "user" && (
                        <Link
                            to="/dashboard"
                            className="btn-ghost"
                            data-testid="nav-dashboard"
                        >
                            Dashboard
                        </Link>
                    )}
                    {user && user.role === "admin" && (
                        <Link
                            to="/admin"
                            className="btn-ghost flex items-center gap-1.5"
                            data-testid="nav-admin"
                        >
                            <Shield size={15} /> Admin
                        </Link>
                    )}
                </nav>

                <div className="flex items-center gap-2">
                    {/* <LanguageSwitcher className="hidden sm:inline-flex" /> */}
                    {!user ? (
                        <>
                            <Link
                                to="/login"
                                className="btn-ghost"
                                data-testid="nav-login"
                            >
                                Login
                            </Link>
                            <Link
                                to="/register"
                                className="btn-primary"
                                data-testid="nav-register"
                            >
                                Get Started
                            </Link>
                        </>
                    ) : (
                        <>
                            <div className="hidden sm:flex items-center gap-2 px-3 py-2 border border-zinc-200 text-xs">
                                <UserIcon size={14} />
                                <span className="font-mono">{user.email}</span>
                                {user.role === "user" && (
                                    <span className="ml-2 px-1.5 py-0.5 g-violet text-white font-bold">
                                        {user.credits_remaining || 0} credits
                                    </span>
                                )}
                                {user.role === "admin" && (
                                    <span className="ml-2 px-1.5 py-0.5 g-sunset text-white font-bold">
                                        ADMIN
                                    </span>
                                )}
                            </div>
                            <button
                                className="btn-secondary flex items-center gap-2"
                                onClick={async () => {
                                    await logout();
                                    nav("/");
                                }}
                                data-testid="nav-logout"
                            >
                                <SignOut size={14} /> Logout
                            </button>
                        </>
                    )}
                </div>
            </div>
        </header>
    );
}
